module.exports = __webpack_public_path__ + "static/media/urbanIcon2.017ddf73.svg";